/* eslint-disable */

import React, { useState } from "react";
import TablePaginate from "components/TablePaginate/TablePaginate";
import ActionRetro from "./ActionRetro";

export default function RetroPoolIndex({ items }) {
  const [page, setPage] = React.useState(0);

  const columns = React.useMemo(
    () => [
      {
        Header: "Pool ID",
        accessor: "poolId",
      },
      // {
      //   Header: "Price",
      //   accessor: "price",
      // },

      {
        Header: "Active",
        accessor: "active",
        Cell: function Tier(cell) {
          return cell.value === true ? "True" : "False";
        },
      },
      {
        Header: "Public Deposits Locked",
        accessor: "publicDepositsLocked",
        Cell: function Tier(cell) {
          return cell.value === true ? "True" : "False";
        },
      },
      {
        Header: "Action",
        Cell: function action({ cell }) {
          return (
            <>
              <ActionRetro item={cell.row.original}></ActionRetro>
            </>
          );
        },
      },
    ],
    []
  );

  return (
    <div>
      {/* {confirm} */}

      {/* <div className={classes.filter}></div> */}

      <TablePaginate
        // count={100}
        page={page}
        setPage={setPage}
        // size={100}
        columns={columns}
        data={items}
      />
    </div>
  );
}
